import { useState, useEffect } from "react";
import InputForm from "../../../components/Form/InputForm.js";
import Chart from "react-apexcharts";
import business from "../../../services/business.js";
import config from "../../../config/config.js";

export default function Operadora() {

    const typeProcess = [
        {
            id: 0,
            nome: "Todos"
        },
        {
            id: 1,
            nome: "Segunda opinião"
        },
        {
            id: 2,
            nome: "Consenso pré"
        },
        {
            id: 3,
            nome: "Junta médica ou odontológica"
        }
    ];

    const [filtros, setFiltros] = useState({
        uf: '',
        id_tipo_processo: '',
        id_operadora: '',
        id_especialidade: '',
        id_area_atuacao: '',
        inicio_processo_inicio: '',
        inicio_processo_fim: '',
        data_conclusao_inicio: '',
        data_conclusao_fim: ''
    });

    const [filtro, setFiltro] = useState(false);

    const setModel = async (name, value) => {
        await setFiltros(prev => ({ ...prev, [name]: value }));
    };

    const [processosAbertosOperadora, setProcessosAbertosOperadora] = useState({
        chart: {
            type: 'bar',
            height: 350
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                borderRadiusApplication: 'end',
                horizontal: true
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: [],
        }
    });

    const [processosFinalizadosOperadora, setProcessosFinalizadosOperadora] = useState({
        chart: {
            type: 'bar',
            height: 350
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                borderRadiusApplication: 'end',
                horizontal: true
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: [],
        }
    });

    const [processosAbertosOperadoraSeries, setProcessosAbertosOperadoraSeries] = useState([
        {
            data: []
        }
    ]);
    const [processosFinalizadosOperadoraSeries, setProcessosFinalizadosOperadoraSeries] = useState([
        {
            data: []
        }
    ]);

    const getSearch = async (loading = true) => {
        setLoading(loading);
        const dadosOperadora = await business.getDesempenhoOperacionalOperadoras({
            uf: filtros.uf,
            id_tipo_processo: filtros.id_tipo_processo,
            id_operadora: filtros.id_operadora,
            id_especialidade: filtros.id_especialidade,
            id_area_atuacao: filtros.id_area_atuacao,
            inicio_processo_inicio: filtros.inicio_processo_inicio,
            inicio_processo_fim: filtros.inicio_processo_fim,
            data_conclusao_inicio: filtros.data_conclusao_inicio,
            data_conclusao_fim: filtros.data_conclusao_fim,
        });

        setProcessosAbertosOperadora(prev => ({
            ...prev,
            xaxis: {
                categories: dadosOperadora?.desempenhoOperadorasAbertos.map(p => p.nome)
            }
        }));

        setProcessosFinalizadosOperadora(prev => ({
            ...prev,
            xaxis: {
                categories: dadosOperadora?.desempenhoOperadorasFinalizados.map(p => p.nome)
            }
        }));

        setProcessosAbertosOperadoraSeries([{
            name: "Quantidade",
            data: dadosOperadora?.desempenhoOperadorasAbertos.map(p => Number(p.quantidade))
        }]);

        setProcessosFinalizadosOperadoraSeries([{
            name: "Quantidade",
            data: dadosOperadora?.desempenhoOperadorasFinalizados.map(p => Number(p.quantidade))
        }]);

        setLoading(false);
        setSearchLoading(false);
    };

    // eslint-disable-next-line 
    const [searchLoading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const limparFiltros = () => {
        setFiltros({});
        setFiltros(false);
        window.location.reload();
    }

    useEffect(() => {
        (async () => {
            await getSearch();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const searchOperadora = async (e) => {
        e.preventDefault();
        return await business.getOperadora(e.target.value);
    }

    const searchEspecialidade = async (e) => {
        e.preventDefault();
        return await business.getEspecialidade(e.target.value);
    };

    const searchAreaAtuacao = async (e) => {
        e.preventDefault();
        return await business.getAreaAtuacao(e.target.value, 12, 1, filtros?.id_especialidade);
    };

    return (
        <>
            <div className="flex ai-fc gap-30 w-100 mb-30 mt-20 justify-content-end">

                <button className={`btn btn-${!filtro ? `outline-` : ''}primary filtros f700-16 jc-sb me-4`} onClick={() => setFiltro(!filtro)}>
                    <span className="desktop">Filtrar </span> <i className={`icon ${!filtro ? `icon-settings-sliders ` : `icon-exit `}i-20 ml-5 blue`} />
                </button>

            </div>
            {filtro && <div className="filtro-consulta form-container grid col-12 mb-30">
                <div className="w-100">
                    <div className="grid col-12 md-gap mb-20">
                        <InputForm
                            label="Tipo de processo"
                            required
                            type="select"
                            className="span-3"
                            name="id_tipo_processo"
                            options={typeProcess}
                            value={filtros?.id_tipo_processo}
                            model={(name, id) => {
                                const selectedProcess = typeProcess.find(process => process.id === Number(id));
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_tipo_processo: selectedProcess?.id || ''
                                }));
                            }}
                        />

                        {config.isSaastoUser() && <InputForm
                            label="Operadora"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchOperadora}
                            name="id_operadora"
                            model={(...params) => {
                                const idOperadora = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_operadora: idOperadora
                                }));
                            }}
                        />}

                        <InputForm
                            label="Especialidade"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchEspecialidade}
                            name="id_especialidade"
                            model={(...params) => {
                                const idEspecialidade = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_especialidade: idEspecialidade
                                }));
                            }}
                        />

                        <InputForm
                            label="Área de atuação"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchAreaAtuacao}
                            name="id_area_atuacao"
                            model={(...params) => {
                                const idAreaAtuacao = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_area_atuacao: idAreaAtuacao
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="w-100">
                    <div className="grid col-12">
                        <InputForm label="Data de início (Inicial)" type="date" id="inicio_processo_inicio" name="inicio_processo_inicio" model={setModel} value={filtros.inicio_processo_inicio} />
                        <span className="text-center interval">-</span>
                        <InputForm className="input-padding" label="Data de início (Final)" type="date" id="inicio_processo_fim" name="inicio_processo_fim" model={setModel} value={filtros.inicio_processo_fim} />
                        <InputForm
                            label="Data de conclusão (Inicial)"
                            type="date"
                            id="data_conclusao_inicio"
                            name="data_conclusao_inicio"
                            model={setModel}
                            value={filtros.data_conclusao_inicio}
                        />
                        <span className="text-center interval">-</span>
                        <InputForm
                            className="input-padding"
                            label="Data de conclusão (Final)"
                            type="date"
                            id="data_conclusao_fim"
                            name="data_conclusao_fim"
                            model={setModel}
                            value={filtros.data_conclusao_fim}
                        />
                        <button className="btn btn-primary f700-16 button-filtrar" onClick={() => {
                            getSearch(1, filtros?.texto || '', true);
                        }}>
                            Aplicar filtros
                        </button>
                        <span className="pointer float-right ml-10 mt-30" onClick={limparFiltros}>
                            <i className="icon icon-trash watermelon i-25" title="Limpar filtros" />
                        </span>
                    </div>
                </div>
            </div>}
            {
                loading ? (
                    <div className="loader loader-default is-active" />
                ) : (
                    <div className="iframe-wrapper mt-5">
                        <div className="text-center">
                            <div className="row align-items-start">
                                <div className="row w-100 grid col-12">
                                    {(filtros.inicio_processo_inicio || filtros.inicio_processo_fim) || (!filtros.inicio_processo_inicio && !filtros.inicio_processo_fim && !filtros.data_conclusao_inicio && !filtros.data_conclusao_fim) ? <div className="col-6">
                                        <div className="text-bg-light mb-2 border rounded p-10" style={{ overflowX: "auto", width: "100%" }}>
                                            <p className="text-start  ms-2"><strong>Processos abertos</strong></p>
                                            <Chart
                                                options={processosAbertosOperadora}
                                                series={processosAbertosOperadoraSeries}
                                                type="bar"
                                                width="800"
                                            />
                                        </div>
                                    </div> : ''}
                                    {(filtros.data_conclusao_inicio || filtros.data_conclusao_fim) || (!filtros.inicio_processo_inicio && !filtros.inicio_processo_fim && !filtros.data_conclusao_inicio && !filtros.data_conclusao_fim) ? <div className="col-6">
                                        <div className="text-bg-light mb-2 border rounded p-10" style={{ overflowX: "auto", width: "100%" }}>
                                            <p className="text-start  ms-2"><strong>Processos finalizados</strong></p>
                                            <Chart
                                                options={processosFinalizadosOperadora}
                                                series={processosFinalizadosOperadoraSeries}
                                                type="bar"
                                                width="800"
                                            />
                                        </div>
                                    </div> : ''}
                                </div>
                            </div>
                        </div>
                    </div >
                )
            }
        </>
    );
}